import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=a29185d4&scoped=true&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=a29185d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29185d4",
  null
  
)

export default component.exports